module.exports = __webpack_public_path__ + "media/promo/courses/images/goalbg-a616cab04f8fb2459f1193f2e79cf9dc.jpg";